<div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-[180px_1fr_1fr] tw:gap-x-0 tw:md:gap-x-6 tw:p-4 tw:border-b tw:border-b-[#eee]">

  <div class="tw:pt-0.5">
    <span class="tw:text-sm tw:font-semibold tw:text-[#333]">{{ student.name }}</span>
  </div>

  <!-- Attainment & Progress -->
  <div class="tw:border-t tw:border-t-[#e5e5e5] tw:pt-[14px] tw:mt-[14px] tw:pl-0 tw:md:border-l tw:md:border-l-[#e5e5e5] tw:md:border-t-0 tw:md:pl-5 tw:md:pt-0 tw:md:mt-0">
    <div class="tw:text-[11px] tw:font-semibold tw:text-[#555] tw:uppercase tw:tracking-[0.04em] tw:mb-3.5">Attainment &amp; Progress</div>

    @for (objective of objectives; track $index) {
      <div class="tw:mb-3.5">
        <div class="tw:text-[11px] tw:text-[#888] tw:mb-1 tw:whitespace-nowrap tw:overflow-hidden tw:text-ellipsis tw:cursor-default" [title]="objectives[$index]">{{ getObjectiveLabel($index) }}</div>
        <leap-v2-attainment-bar
          [step]="student.progress.attainmentLevels[$index]"
          [disabled]="disabled"
          (stepChange)="onAttainmentStep($index, $event)">
        </leap-v2-attainment-bar>
        @if (isAttainmentMissing($index)) {
          <span class="field__error tw:block">Select an attainment score</span>
        }
      </div>
    }

    <div class="tw:text-[11px] tw:text-[#888] tw:mb-1 tw:mt-4">Comments on progress</div>
    <textarea
      class="field__control tw:w-full"
      [(ngModel)]="student.progress.objectiveComments"
      [disabled]="disabled"
      rows="4"
      maxlength="3000"
      [placeholder]="progCommentPlaceholder">
    </textarea>
    <div class="tw:text-[10px] tw:text-[#aaa] tw:text-right tw:-mt-2 tw:mb-1">{{ progressCharCount }} / 3000</div>
    @if (isProgressCommentsMissing) {
      <span class="field__error tw:block">Enter comments on progress</span>
    }
  </div>

  <!-- Engagement -->
  <div class="tw:border-t tw:border-t-[#e5e5e5] tw:pt-[14px] tw:mt-[14px] tw:pl-0 tw:md:border-l tw:md:border-l-[#e5e5e5] tw:md:border-t-0 tw:md:pl-5 tw:md:pt-0 tw:md:mt-0">
    <div class="tw:text-[11px] tw:font-semibold tw:text-[#555] tw:uppercase tw:tracking-[0.04em] tw:mb-3.5">Engagement</div>

    <div class="tw:text-[11px] tw:text-[#888] tw:mb-1">Engagement score</div>
    <leap-v2-engagement-bar
      [value]="student.progress.engagement"
      [disabled]="disabled"
      (valueChange)="student.progress.engagement = $event">
    </leap-v2-engagement-bar>
    @if (isEngagementMissing) {
      <span class="field__error tw:block">Select an engagement score</span>
    }

    <div class="tw:text-[11px] tw:text-[#888] tw:mb-1 tw:mt-4">Engagement comments</div>
    <textarea
      class="field__control tw:w-full"
      [(ngModel)]="student.progress.engagementComments"
      [disabled]="disabled"
      rows="4"
      [placeholder]="engCommentPlaceholder">
    </textarea>
    @if (isEngagementCommentsMissing) {
      <span class="field__error tw:block">Enter engagement comments</span>
    }

    <div class="tw:mt-4">
      <!-- Files already uploaded to this session. Each opens through the API, which checks the caller may see it. -->
      @if (shownSavedEvidence.length > 0) {
        <ul class="saved-evidence tw:list-none tw:p-0 tw:mb-2 tw:flex tw:flex-col tw:gap-[5px]">
          @for (f of shownSavedEvidence; track f.url) {
            <li class="tw:text-xs"><a href="" (click)="openEvidence($event, f)">{{ f.name }}</a></li>
          }
        </ul>
      }
      <leap-v2-evidence-upload
        [disabled]="disabled"
        (filesChanged)="onEvidenceChanged($event)">
      </leap-v2-evidence-upload>
    </div>

    <div class="tw:mt-4">
      @if (concern) {
        <!-- Indicator only: a raised concern is read back from the dialog, never edited (one per learner per session). -->
        <button
          mat-flat-button
          color="warn"
          [title]="concern.reason"
          (click)="openBehaviouralConcern()">
          ⚑ Behavioural incident raised
        </button>
      } @else {
        <button
          mat-stroked-button
          color="warn"
          [disabled]="disabled || !canRaiseConcern"
          (click)="openBehaviouralConcern()">
          ⚑ Report behavioural incident
        </button>
      }
    </div>
  </div>

</div>
